import React, { useState } from "react";
import { Box } from "@mui/material";
import AuthGate from "../routing/components/AuthGate";
import { Role } from "../constants/roles";
import { useAuth } from "../context/AuthContext";
import { GlobalTabCollection, StyledTab } from "../pages/styles";

export type TabConfig = {
  component: React.ReactNode;
  restrictedToRoles: Role[];
};

export type TabKey = string | number | symbol;

export type TabCollection = Record<TabKey, TabConfig>;

interface ProtectedTabsProps {
  tabs: TabCollection;
  defaultTab: TabKey;
}

export const ProtectedTabs = ({ tabs, defaultTab }: ProtectedTabsProps) => {
  const { hasAnyRole } = useAuth();
  const [tabValue, setTabValue] = useState<TabKey>(defaultTab);

  const visibleTabs = Object.entries(tabs).filter(([__dirname, config]) => {
    return hasAnyRole(config.restrictedToRoles);
  });

  const handleTabChange = (
    _event: React.SyntheticEvent,
    newValue: React.SetStateAction<TabKey>,
  ) => {
    setTabValue(newValue);
  };

  return (
    <>
      <Box sx={{ bgcolor: "#fff", pt: 3, pb: 1 }}>
        <GlobalTabCollection value={tabValue} onChange={handleTabChange} aria-label="ant example">
          {visibleTabs.map(([key]) => (
            <StyledTab value={key} label={key} />
          ))}
        </GlobalTabCollection>
        <Box sx={{ p: 3 }} />
      </Box>
      <AuthGate restrictedToRoles={tabs[tabValue].restrictedToRoles}>
        {tabs[tabValue].component}
      </AuthGate>
    </>
  );
};
